export default __webpack_public_path__ + "e8d895ee4dfeac543965a283b009d0ef.svg";